<template>
    <div class="relative bg-primary">
        <div class="container">
            <div class="relative flex justify-between pt-44 xs:pt-28">
                <div class="items-center hidden sm:flex gap-x-4">
                    <span class="text-xl font-light text-white">01</span>
                    <div class="h-[1px] w-28 bg-white"></div>
                    <span class="text-xl font-light text-white">
                        {{ getProjectCount }}
                    </span>
                </div>
                <!--
                    Filter
                    Pass projects to watch in child component on project load
                -->
                <WidgetProjectsFilter
                    :projects="projects"
                    @updateFilter="updateFilter"
                />
            </div>

            <!-- Projects -->
            <div
                id="projects-container"
                class="relative flex flex-col pb-24 mt-6 xs:mt-8 md:mt-16 gap-y-20 sm:gap-y-48"
            >
                <WidgetProjectCard
                    v-for="project in projects"
                    :id="project.title"
                    :key="project.title"
                    :class="{ hidden: project.hidden }"
                    :hidden="project.hidden"
                    :name="project.title"
                    :categories="project.categories"
                    :image="`${config.public.contentApiUrl}/assets/${project.image}?width=1300&height=650&quality=90&format=webp`"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const projectStore = useProjectStore();

// Meta
definePageMeta({
    title: 'works.meta.title',
    description: 'works.meta.description',
});

// Data
const projectsFilter = ref(['' as any]);
const projects = ref([]) as Ref<Array<Record<string, any>>>;
const hiddenProjects = ref([]);
const projectCount = ref(0);

// Watchers
watch(projects, () => getProjectCount);

// Methods
const fetchProjects = async () => {
    try {
        const res = await useFetch(
            `${config.public.contentApiUrl}/items/rb_portfolio_projects`,
        );
        const resData = res.data.value as Record<string, any>;

        if (!resData) {
            return;
        }

        projects.value = resData.data;
        projects.value.forEach((project: Record<string, any>) => {
            if (project.status === 'draft' || project.status === 'archived')
                project.hidden = true;
            else project.hidden = false;
        });
    } catch (err: any) {
        console.log(err);
        // (this as any).$sentry.captureException(err);
    }
};
const updateFilter = (newFilter: Array<string>) => {
    projectsFilter.value = newFilter;

    filterProjects();
};
const filterProjects = () => {
    projects.value.forEach((project: Record<string, any>) => {
        let categoryContained = false;
        for (let i = 0; project.categories.length >= i; i++) {
            if (projectsFilter.value.includes(project.categories[i])) {
                categoryContained = true;
            } else if (projectsFilter.value.length === 0) {
                categoryContained = true;
            }
        }

        const projectIndex = projects.value.indexOf(project);
        const status = projects.value[projectIndex].status;
        if (status !== 'draft' && status !== 'archived') {
            if (categoryContained) {
                projects.value[projectIndex].hidden = false;
            } else {
                projects.value[projectIndex].hidden = true;
            }
        }
    });
};
const getProjectCount = computed(() => {
    let count = 0;
    projects.value.forEach((project: Record<string, any>) => {
        if (
            !project.hidden &&
            project.status !== 'draft' &&
            project.status !== 'archived'
        )
            count++;
    });

    return count > 10 ? count : '0' + count;
});

fetchProjects();
</script>
